<template>
  <v-btn small color="rgba(255, 255, 255, 0.15)" @click="submitLogout">
    <v-icon small class="mr-2">mdi-logout</v-icon>
    로그아웃
  </v-btn>
</template>

<script>
import { mapActions} from 'vuex';

export default {
  name: 'LogoutForm',
  data() {
    return {
      checkClick: false,
    }
  },
  methods: {
    ...mapActions('user', ['logout']),
    submitLogout() {
      this.logout()
        .then(() => {
          if (this.$router.currentRoute.path !== '/') {
            this.$router.push({ path: '/' });
          }
        })
        .catch(error => {
          console.error('Logout error:', error);
        });
    },
  }
}
</script>

<style lang="scss" scoped></style>